export type ThemeName = 'default' | 'halloween' | 'thanksgiving' | 'christmas' | 'cny';

const THEME_COLOR_BY_NAME: Record<ThemeName, string> = {
  default: '#0ea5e9',
  halloween: '#f97316',
  thanksgiving: '#b45309',
  christmas: '#065f46', // deep evergreen
  cny: '#dc2626', // festive red
};

export function applyTheme(theme: ThemeName): void {
  const root = document.documentElement;
  root.setAttribute('data-theme', theme);

  const meta = document.querySelector('meta[name="theme-color"]') as HTMLMetaElement | null;
  if (meta) {
    meta.content = THEME_COLOR_BY_NAME[theme];
  }
}

export function applyThemeFromEnv(): void {
  const envTheme = import.meta.env?.VITE_THEME;
  switch (envTheme) {
    case 'halloween':
      applyTheme('halloween');
      break;
    case 'thanksgiving':
      applyTheme('thanksgiving');
      break;
    case 'christmas':
      applyTheme('christmas');
      break;
    case 'cny':
      applyTheme('cny');
      break;
    default:
      applyTheme('default');
  }
}

export function getCurrentTheme(): ThemeName {
  const envTheme = import.meta.env?.VITE_THEME;
  if (envTheme === 'halloween' || envTheme === 'thanksgiving' || envTheme === 'christmas' || envTheme === 'cny') {
    return envTheme;
  }
  return 'default';
}

export function getLogoPath(): string {
  return getCurrentTheme() === 'cny' ? '/assets/logo-fu.png' : '/assets/bhcs-logo.png';
}


